import { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  TextField,
  DialogActions,
  Typography,
} from "@mui/material";
import postApiData from "../../../../../hooks/apiRequests/postsRequest";
import { useToast } from "../../../../shared/toastMessages/toastProvider";

const buttonSx = {
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  whiteSpace: "nowrap",
};

const ForceSetPassword = ({ email, theme }) => {
  const [openModal, setOpenModal] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const { showToast } = useToast();

  const handleModal = () => {
    setOpenModal((prev) => !prev);
    setPassword("");
    setConfirm("");
    setError("");
  };

  const handleConfirm = async () => {
    if (password !== confirm) {
      setError("Passwords need to match.");
      return;
    }
    if (password.length < 8) {
      setError("Password needs to be at least 8 characters.");
      return;
    }

    setSaving(true);
    try {
      const response = await postApiData("/User/ChangePassword", {
        email,
        password,
      });
      if (response) {
        setError("");
        handleModal();
        showToast("User Password Updated Successfully!", "success");
      } else {
        setError("Could not update password.");
        showToast("Unable To Update Password", "error");
      }
    } catch (err) {
      console.error(`Error processing Add request:`, err);
      setError("API update error. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button
        onClick={handleModal}
        variant="outlined"
        theme={theme}
        fullWidth
        sx={buttonSx}
      >
        Set password
      </Button>
      <Dialog open={openModal} onClose={handleModal} fullWidth maxWidth="sm">
        <DialogTitle sx={{ fontWeight: 600 }}>Set user password</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Force set a new password for this user.
          </Typography>
          <Stack spacing={2}>
            <TextField
              label="Password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              type="password"
              size="small"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
            />
            <TextField
              label="Confirm password"
              name="confirm password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              fullWidth
              type="password"
              size="small"
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "10px" } }}
            />
          </Stack>
          {error ? (
            <Typography variant="body2" color="error" sx={{ mt: 1.5 }}>
              {error}
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleModal} color="inherit" sx={buttonSx} theme={theme}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="primary"
            disabled={saving}
            theme={theme}
            sx={buttonSx}
          >
            {saving ? "Saving..." : "Save password"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ForceSetPassword;
